import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { SET_DEVICE } from '../../store/app';
import { useAppSelector } from '../../store';
// import { defHttp } from '../../service/http/axios';
import './index.less';
import { storage } from '../../utils/storage';
// import { useDispatch } from "react-redux";
// import { AnyAction, Dispatch } from 'redux';

import proof, { data as AuthData } from '../../utils/proof';
import { Base64Encryption } from '../../utils/encryption';

type USER = {
    id: string,
    username: string
}

const DevPage = () => {

    // const dispatch: Dispatch<AnyAction> = useDispatch();

    const _info: USER = { id: '', username: '' };
    const [userInfo, setUserInfo] = useState(_info)

    // const dispatch: Dispatch<any> = useDispatch()
    // const [article, setArticle] = useState<IArticle | {}>();
    // const articles: readonly IArticle[] = useSelector(
    //     (state: ArticleState) => state.articles,
    //     shallowEqual
    // )

    // const count = useAppSelector((state) => state.app.value)
    // const dispatch = useAppDispatch()
    // const count = useAppSelector((state) => state.app.value)
    // const dispatch = useAppDispatch()

    const dispatch: Dispatch<any> = useDispatch();
    const deviceValue = useAppSelector(state => state.app.device);

    const addFn = async () => {

        // console.log(count);
        await dispatch(SET_DEVICE('new device text'));
        console.log(deviceValue);
    }

    useEffect(() => {
        
        // console.log(storage.get('device', ''));
        // console.log(articles);

        const sources = proof.Permissions.map(t => t.source);
        console.log(sources);

        const proofValue = proof.initUserCode(sources);
        console.log(proofValue);

        const encryptProofValue = Base64Encryption(proofValue as string);
        console.log(encryptProofValue);

        const hasRt01 = proof.checkPermission(AuthData.RT1000);
        console.log('hasRt01 : ', hasRt01);

        const hasRt02 = proof.checkPermission(AuthData.RT2000);
        console.log('hasRt02 : ', hasRt02);

        proof.delPermission(AuthData.RT2000);
        const hasRt03 = proof.checkPermission(AuthData.RT2000);
        console.log('hasRt03 : ', hasRt03);

        (async () => {
            // console.log(deviceValue);
            // const info = await dispatch({
            //     type: "app/getUserinfo",
            //     payload: { id: 1 },
            // });
            // setUserInfo(info as any);
            // console.log("获取到userInfo:", userInfo);
        })();
    }, []);


    return (
        <div className='page-container'>
            <h1>dev page</h1>
            <h1>{userInfo?.username || '--'}</h1>
            <button onClick={addFn}>add</button>
        </div >
    );
}

export default DevPage;
